module.exports = __webpack_public_path__ + "media/images/img-thx-support-ea940d411db3bd9f6e34fbf5b49bb6fd.svg";